/**
 * Beautiful Selection - <bs-installments>: "Or 3 interest-free payments of R250.00 with Payflex" under the price
 * (blocks/bs-installments.liquid). Recalculates on variant change and hides outside the provider's range.
 * Ported from the Wanderlust lesson (wj-core.js WjInstallments). No imports from Horizon.
 */

/**
 * @param {number} cents
 * @param {string} [format]
 */
function formatMoney(cents, format = 'R{{amount}}') {
  const group = (value, decimals, thousands, decimal) => {
    const [whole, frac] = (value / 100).toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
    switch (kind) {
      case 'amount_no_decimals':
        return group(cents, 0, ',', '.');
      case 'amount_with_comma_separator':
        return group(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return group(cents, 0, '.', ',');
      case 'amount_with_space_separator':
        return group(cents, 2, ' ', ',');
      default:
        return group(cents, 2, ',', '.');
    }
  });
}

class BsInstallments extends HTMLElement {
  connectedCallback() {
    this.update(Number(this.dataset.price));
    if (this.hasAttribute('data-static')) return; // cart total: no variant events
    // Horizon's variant event; match on the raw product id in result.detail.productId (as Horizon's product-price.js).
    this.onVariant = (event) => {
      const source = event?.target;
      if (!(source instanceof Element) || (source.closest('product-card') && !source.closest('product-card')?.contains(this))) return;
      event.promise
        ?.then((result) => {
          const detail = result?.detail;
          if (!detail) return;
          if (detail.newProduct) this.dataset.productId = String(detail.newProduct.id);
          else if (detail.productId && this.dataset.productId && String(detail.productId) !== this.dataset.productId) return;
          const price = detail.resource?.price;
          if (typeof price === 'number') this.update(price);
        })
        .catch(() => {});
    };
    document.addEventListener('shopify:product:select', this.onVariant);
  }

  disconnectedCallback() {
    if (this.onVariant) document.removeEventListener('shopify:product:select', this.onVariant);
  }

  /** @param {number} cents */
  update(cents) {
    const n = Number(this.dataset.count) || 3;
    const min = Number(this.dataset.min) || 0;
    const max = Number(this.dataset.max) || Infinity;
    const amount = this.querySelector('[data-amount]');
    this.hidden = !(cents >= min && cents <= max);
    if (amount) amount.textContent = formatMoney(Math.round(cents / n), this.dataset.moneyFormat);
  }
}

if (!customElements.get('bs-installments')) customElements.define('bs-installments', BsInstallments);
